import { render, staticRenderFns } from "./DettaglioSicurezza.vue?vue&type=template&id=3dc9f6ef"
import script from "./DettaglioSicurezza.vue?vue&type=script&lang=js"
export * from "./DettaglioSicurezza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports